<template>
  <div v-cloak>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion-carta' }">{{
                $t("configuracionCarta")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ $t("horarios") }}
            </li>
          </ol>
        </nav>
      </div>

      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label>{{ $t("negocio") }}</label>

                <el-select
                  class="select-default"
                  size="large"
                  v-model="idBusiness"
                  filterable
                  :placeholder="$t('seleccionaNegocio')"
                  @change="cambioNegocio()"
                >
                  <el-option
                    v-for="business in listBusinesses"
                    class="select-primary"
                    :value="business.id"
                    :label="business.establishmentName"
                    :key="business.establishmentName"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12" v-if="respuesta">
        <div class="card">
          <div class="row">
            <div class="col-md-8">
              <div class="form-group">
                <button
                  v-if="newButton"
                  @click="openModal()"
                  class="btn btn-primary"
                >
                  <i class="fa fa-plus-square"></i>
                  {{ $t("nuevoHorario") }}
                </button>
                <button
                  v-if="newButton && listBusinesses.length > 1 && !esSelfi"
                  @click="openModalReplicar()"
                  class="btn btn-secondary"
                >
                  <i class="fa fa-sitemap"></i>
                  {{ $t("replicar") }}
                </button>
                <div v-else></div>
              </div>
            </div>
          </div>

          <!--<div  class="form-group">
                        <label>Hora fin</label>
                        <datetime
                                :auto="true"
                                type="time"
                                class="theme-numier"
                                title="Hora fin"
                                :phrases="{ok: 'Aceptar', cancel: 'Salir'}"
                                input-class="form-control"
                                format="HH:mm"
                                v-model="hoursto"></datetime>
                    </div>-->

          <div
            class="table-responsive"
            v-if="listHorarios.length > 0 && respuesta"
          >
            <table class="table table-bordered table-striped">
              <thead class="thead-dark">
                <tr>
                  <th>{{ $t("diaDeLaSemana") }}</th>
                  <th>{{ $t("horaInicio") }}</th>
                  <th>{{ $t("horaFin") }}</th>
                  <th v-if="!esSelfi">{{ $t("tipoDeEnvio") }}</th>
                  <th width="10%">{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="horario in listHorarios" :key="horario.id">
                  <td>
                    <div>{{ horario.diadelasemana }}</div>
                  </td>
                  <td>
                    <div v-if="horario.hora_inicio">
                      {{ horario.hora_inicio.substring(0, 5) }}
                    </div>
                  </td>
                  <td>
                    <div v-if="horario.hora_fin">
                      {{ horario.hora_fin.substring(0, 5) }}
                    </div>
                  </td>
                  <td v-if="!esSelfi">
                    <div>{{ horario.tipoEnvio }}</div>
                  </td>
                  <td>
                    <div>
                      <a
                        @click="getHorario(horario.id)"
                        class="btn btn-danger btn-link btn-xs"
                      >
                        <i
                          v-tooltip.top-center="$i18n.t('editar')"
                          class="fas fa-pencil-alt"
                          style="color: orange"
                        ></i>
                      </a>
                      <a
                        @click="modalBorrarHorario(horario.id)"
                        class="btn btn-danger btn-link btn-xs"
                      >
                        <i
                          v-tooltip.top-center="$i18n.t('borrarHorario')"
                          class="fas fa-trash-alt text-danger"
                        ></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="alert alert-danger" role="alert">
            <span v-if="newButton">{{ $t("noHayHorariosEnEsteNegocio") }}</span>
            <span v-else>{{ $t("esteNegocioNoTieneCarta") }}</span>
          </div>
        </div>
      </div>
    </div>

    <modal
      name="modal-horario"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("horarios") }}</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>{{ $t("diaDeLaSemana") }}</label>
            <el-select
              class="select-default"
              size="large"
              v-model="diaSeleccionado"
              :selected="listDias[diaSeleccionado]"
              filterable
              :placeholder="$t('seleccioneDiaDeLaSemana')"
            >
              <el-option
                v-for="dia in listDias"
                class="select-primary"
                :value="dia.value"
                :label="dia.dia"
                :key="dia.value"
              >
              </el-option>
            </el-select>
            <!--<input type="text" class="form-control"
                               v-model="diaDeLaSemana"
                               id="diaHorario">-->
          </div>

          <div class="form-group">
            <label>{{ $t("horaInicio") }}</label>
            <datetime
              value-zone="Europe/Madrid"
              :auto="true"
              type="time"
              class="theme-numier"
              :title="$t('horaInicio')"
              :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
              input-class="form-control"
              format="HH:mm"
              v-model="hoursfrom"
            ></datetime>
          </div>
          <div class="form-group">
            <label>{{ $t("horaFin") }}</label>
            <datetime
              value-zone="Europe/Madrid"
              :auto="true"
              type="time"
              class="theme-numier"
              :title="$t('horaFin')"
              :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
              input-class="form-control"
              format="HH:mm"
              v-model="hoursto"
            ></datetime>
          </div>
          <div class="form-group" v-if="!esSelfi">
            <label>{{ $t("tipoDeEnvio") }}</label>
            <el-select
              class="select-default"
              size="large"
              v-model="tipoEnvio"
              :selected="listTipoEnvio[tipoEnvioSeleccionado]"
              filterable
              :placeholder="$t('seleccioneTipoDeEnvio')"
            >
              <el-option
                v-for="tipo in listTipoEnvio"
                class="select-primary"
                :value="tipo.value"
                :label="tipo.tipo"
                :key="tipo.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button class="btn btn-danger" @click="closeModal()">
              <i class="fa fa-window-close"></i>
              {{ $t("cancelar") }}
            </button>

            <button class="btn btn-primary" @click="saveHorario()">
              <i class="fa fa-check-square"></i>
              {{ $t("guardar") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="modal-replicar"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="false"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("horarios") }}</h4>
        </div>
        <div class="modal-body">
          <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >{{ $t('seleccionarTodos') }}</el-checkbox
            >
            <div style="margin: 15px 0;"></div>

            <el-checkbox-group
              v-model="checkedBusinesses"
              @change="handleCheckedCitiesChange"
            >
               <el-checkbox 
                v-for="business in filtrarEmpresasExtras" 
                :label="business"
                :disabled="!business.tienePedidos"
                :key="business.id">
                  {{ business.establishmentName }}                
              </el-checkbox>
            </el-checkbox-group>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button class="btn btn-danger" @click="closeModalReplicar()">
              <i class="fa fa-window-close"></i>
              {{ $t("cancelar") }}
            </button>

            <button class="btn btn-primary" @click="saveReplicas()">
              <i class="fa fa-check-square"></i>
              {{ $t("aplicarCambios") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  CheckboxGroup
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import ValesVue from '../../../Informes/Ventas/Widgets/Vales.vue';

export default {
  created() {
    //            this.loading = Loading.service({text: 'Cargando...'});
    this.$store.dispatch("setNameRoute", this.$i18n.t("horarios"));
    this.getBusiness();

    if (this.$store.getters.idBusiness) {
      this.idBusiness = this.$store.getters.idBusiness;
    }

    this.checkIsSelfi();

  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup
  },
  data() {
    return {
      loading: false,
      listBusinesses: [],
      idBusiness: this.$route.params.idBusiness,
      idBusinessInfo: null,
      searchQuery: this.$route.params.query,
      isSearch: false,
      pag: this.$route.params.pag,
      totalPags: 0,
      respuesta: true,
      newButton: false,
      idTPV: 0,
      listHorarios: ["-"], // Pongo '-' para cuando cargue la vista no se vea el rojo de no hay elementos
      diaSeleccionado: "",
      tipoEnvioSeleccionado: "",
      listDias: [
        { value: 1, dia: "Lunes" },
        { value: 2, dia: "Martes" },
        { value: 3, dia: "Miercoles" },
        { value: 4, dia: "Jueves" },
        { value: 5, dia: "Viernes" },
        { value: 6, dia: "Sábado" },
        { value: 7, dia: "Domingo" },
      ],
      listTipoEnvio: [
        { value: "", tipo: "Ambos (R y D)" },
        { value: "M", tipo: "Mesa" },
        { value: "R", tipo: "Para recoger" },
        { value: "D", tipo: "A domicilio" },
      ],

      hoursfrom: "2020-11-17T00:00:00.000+01:00",
      hoursto: "2020-11-17T23:59:59.000+01:00",
      tipoEnvio: "",

      idHorario: null,
      checkAll: false,
      isIndeterminate: false,
      checkedBusinesses: [],
      esSelfi : false,
    };
  },
  watch: {
    hoursto() {
      setTimeout(() => this.checkHoras("fin"), 100);
    },
    hoursfrom() {
      setTimeout(() => this.checkHoras("inicio"), 100);
    },
    $route(to, from) {
      if (to.params.pag) {
        this.pag = to.params.pag;
        this.getHorarios();
      } else if (to.params.query) {
        this.query = to.params.query;
        this.getHorarios();
      }
    },
  },

  computed:{
    filtrarEmpresasExtras() {
      var res = this.listBusinesses.filter(listBusinesses =>{ return listBusinesses.id !== this.idBusiness })
      return res;
    },
    filtrarEmpresasConCarta() {
      var res = this.listBusinesses.filter(listBusinesses =>{ return listBusinesses.id !== this.idBusiness && listBusinesses.tienePedidos})
      return res;
    },

  },

  methods: {

    checkIsSelfi() {
      let vm = this;

      const esSelfiCookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("esSelfi="));

      // Verificar si la cookie existe antes de intentar acceder a su valor
      if (esSelfiCookie) {
        vm.esSelfi = esSelfiCookie.split("=")[1];
      } else {
        vm.esSelfi = false;
      }
    },


    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUserPedidos", config)
        .then(function(response) {

          if (response.data.response) {
            if (!vm.idBusiness) {
              vm.idBusiness = response.data.result[0].id;
            }

            vm.listBusinesses = response.data.result;
            vm.getHorarios();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
          
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getBusinessInfo() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.$store.dispatch("setIdBusiness", this.idBusiness);

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getIdBusinessInfo", config)
        .then(function(response) {
          if (response.data.response) {
            vm.idBusinessInfo = response.data.result;

            vm.newButton = true;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("esteNegocioNoTieneCarta"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
            vm.newButton = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    checkHoras(horaCambiada) {
      let fechaDesHours = moment(this.hoursfrom).format("HH:mm:ss");
      let fechaHastHours = moment(this.hoursto).format("HH:mm:ss");

      if (fechaDesHours > fechaHastHours) {
        swal({
          title: this.$t("atencion"),
          text: this.$t("laHoraInicioNoPuedeSerMayorQueLaHoraFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        if (horaCambiada == "inicio") {
          this.hoursfrom = "2020-11-17T00:00:00.000+01:00";
        } else {
          this.hoursto = "2020-11-17T23:59:59.000+01:00";
        }
      }
    },
    getHorarios() {
      var config = {
        params: {
          pag: this.pag,
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.$store.dispatch("setIdBusiness", this.idBusiness);

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "delivery/getHorarios", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listHorarios = response.data.result;
            //vm.idBusinessInfo = response.data.result[0].idBusinessInfo;

            vm.respuesta = true;
            vm.getBusinessInfo();
          } else if (response.data.result == "") {
            swal({
              title: vm.$t("atencion"),
              text: vm.$t("esteNegocioNoTieneCarta"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    cambioNegocio() {
      this.pag = 1;
      this.totalPags = 0;

      this.getHorarios();
    },
    getHorario(id) {
      this.idHorario = id;

      const controller = "getHorarioById";
      var config = {
        params: {
          idHorario: this.idHorario,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      this.$store.dispatch("setIdBusiness", this.idBusiness);

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "delivery/" + controller, config)
        .then(function(response) {
          if (response.data.response) {
            vm.hoursfrom = response.data.result[0].hora_inicio;
            vm.hoursto = response.data.result[0].hora_fin;
            vm.tipoEnvio = response.data.result[0].tipoEnvio;
            vm.idHorario = response.data.result[0].id;
            vm.idBusinessInfo = response.data.result[0].idBusinessInfo;

            vm.listDias.forEach((dia) => {
              if (dia.dia == response.data.result[0].diadelasemana) {
                vm.diaSeleccionado = dia.value;
              }
            });

            vm.listTipoEnvio.forEach((tipo) => {
              if (tipo.value == "" && tipo.value == vm.tipoEnvio) {
                vm.tipoEnvioSeleccionado = 0;
              }
              if (tipo.value == "R" && tipo.value == vm.tipoEnvio) {
                vm.tipoEnvioSeleccionado = 1;
              } else if (tipo.value == "D" && tipo.value == vm.tipoEnvio) {
                vm.tipoEnvioSeleccionado = 2;
              } else {
                vm.tipoEnvioSeleccionado = 3;
              }

            });

            vm.openModal();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });

            vm.respuesta = false;
          }

          //                        vm.loading.close();
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    saveHorario() {
      if (this.diaSeleccionado === "") {
        swal({
          title: this.$t("atencion"),
          text: this.$t("elCampoDiaDeLaSemanaEsRequerido"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let fechaDesHours = moment(this.hoursfrom).format("HH:mm:ss");
        let fechaHastHours = moment(this.hoursto).format("HH:mm:ss");

        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        //* Si es de Selfi por defefecto se marca el recoger
        if (this.esSelfi) {
          this.tipoEnvio = 'R';
        }
        
        var params = {
          idBusinessInfo: this.idBusinessInfo,
          hora_inicio: fechaDesHours,
          hora_fin: fechaHastHours,
          diaDeLaSemana: this.diaSeleccionado,
          tipoEnvio: this.tipoEnvio,
          idHorario: this.idHorario,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = this.idHorario ? "editHorario" : "newHorario";
        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/" + controller,
            params,
            config
          )
          .then(function(response) {
            if (response.data.response) {
              let notify = vm.idHorario
                ? vm.$t("actualizado")
                : vm.$t("creado");
              vm.$notify({
                message:
                  vm.$t("horario") + notify + " " + vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.getHorarios();

              vm.$modal.hide("modal-horario");
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            vm.inProgress = false;
          });

        this.idHorario = null;
        this.diaSeleccionado = "";
        this.tipoEnvio = "";
        this.hoursfrom = "2020-11-17T00:00:00.000+01:00";
        this.hoursto = "2020-11-17T23:59:59.000+01:00";
      }
    },

    closeModal() {
      this.$modal.hide("modal-horario");
      this.diaSeleccionado = "";
      this.tipoEnvio = "";
      this.hoursfrom = "2020-11-17T00:00:00.000+01:00";
      this.hoursto = "2020-11-17T23:59:59.000+01:00";
    },

    openModal() {
      this.$modal.show("modal-horario");
    },

    openModalReplicar() {
      this.$modal.show("modal-replicar")
    },

    closeModalReplicar() {
      this.$modal.hide("modal-replicar");
      this.diaSeleccionado = "";
      this.tipoEnvio = "";
      this.hoursfrom = "2020-11-17T00:00:00.000+01:00";
      this.hoursto = "2020-11-17T23:59:59.000+01:00";
    },


    saveReplicas() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };
      var params = {
        idBusinessOriginal: this.idBusinessInfo,
        negocios: this.checkedBusinesses, 
      };

      let vm = this;
      let controller = "replyHorarios";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            
            vm.$notify({
              message:
                vm.$t("horario") + " " + vm.$t("replicado") + " " + vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.getHorarios();
            vm.$modal.hide("modal-replicar");

          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });

        this.idHorario = null;
        this.diaSeleccionado = "";
        this.tipoEnvio = "";
        this.hoursfrom = "2020-11-17T00:00:00.000+01:00";
        this.hoursto = "2020-11-17T23:59:59.000+01:00";
    },



    handleCheckAllChange(val) {
        this.checkedBusinesses = val ? this.filtrarEmpresasConCarta : [];
        this.isIndeterminate = false;
    },

    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.listBusinesses.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.listBusinesses.length;
      this.checkedBusinesses = value;
    },

    deleteHorario(id) {
      var params = {
        jwt: this.$store.getters.jwt,
        idHorario: id,
      };

      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      let controller = "deleteHorario";
      this.axios
        .post(
          this.$store.getters.apiUrl + "delivery/" + controller,
          params,
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.$notify({
              message:
                vm.$t("horario") +
                vm.$t("eliminado") +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.getHorarios();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    modalBorrarHorario(id) {
      swal({
        title: this.$t("deseaEliminarEsteHorario"),
        text: this.$t("estaOperacionNoSePuedeDeshacer"),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: this.$t("siBorrarHorario"),
        cancelButtonText: this.$t("cancelar"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.deleteHorario(id);
        }
      });
    },
  },
};
</script>

<style scoped>
[v-cloak] {
  display: none;
}

tbody tr:hover {
  background-color: rgba(0, 153, 130, 0.2);
}

tbody td {
  padding: 0 !important;
}

td div {
  padding: 12px 8px;
  color: #333;
}

.buttonsSearch:hover {
  cursor: pointer;
  background-color: rgba(0, 153, 130, 0.1);
}

.card {
  padding: 20px;
}

.input-group button {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Horarios/ConfiguracionHorarios.vue